"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _lodash = require("lodash");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var mergeNestedObjects = function mergeNestedObjects(_ref) {
  var defaultConstantsPath = _ref.defaultConstantsPath,
      customConstantsPath = _ref.customConstantsPath;
  return Object.keys(customConstantsPath).reduce(function (newSlice, customConstantKey) {
    var nextDefaultConstantsStep = defaultConstantsPath[customConstantKey];
    var nextCustomConstantsStep = customConstantsPath[customConstantKey];
    /**
     * If BOTH the default constant and the new constant are BOTH objects,
     * then traverse further down.
     *
     * Otherwise the new constant will overwrite the default as long as it
     * actually exists.
     */

    if (typeof nextCustomConstantsStep !== 'string' && !nextCustomConstantsStep) {
      return newSlice;
    }

    if ((0, _lodash.isPlainObject)(nextDefaultConstantsStep) && (0, _lodash.isPlainObject)(nextCustomConstantsStep)) {
      var payload = mergeNestedObjects({
        defaultConstantsPath: nextDefaultConstantsStep,
        customConstantsPath: nextCustomConstantsStep
      });
      return _objectSpread(_objectSpread({}, newSlice), {}, _defineProperty({}, customConstantKey, payload));
    }

    return _objectSpread(_objectSpread({}, newSlice), {}, _defineProperty({}, customConstantKey, nextCustomConstantsStep));
  }, _objectSpread({}, defaultConstantsPath));
};

var _default = function _default() {
  var defaultConstants = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var customConstants = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return mergeNestedObjects({
    defaultConstantsPath: defaultConstants,
    customConstantsPath: customConstants
  });
};

exports.default = _default;